import { Checkbox, Divider, FormControlLabel, Grid, makeStyles, Radio, RadioGroup, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { handlePodQualityManagement, openPodQualityManagement, showAlertSnackbar } from "../../reducers/uiSlice";
import { getUserPreference } from "../../utilities/common";
import UniDialog from "../Common/UniDialog";
import FullscreenLoading from "../Common/FullscreenLoading";
import { downloadPodQualityExcelBlob } from "../../actions/podQualityActions";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '80vh'
    },
    scopeStyle: {
        padding: theme.spacing(2)
    },
    margin: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    }
}));

const COUNT_MAX = 50;
const COUNT_MIN = 1;

const searchType = {
    DATE: 0,
    BATCH: 1,
    MULTI_SEARCH: 2,
    SUB_REFERENCE: "sub_reference",
    REFERENCE:"reference"
};


function PodQualityManagement() {
    const { t } = useTranslation('podQualityManagement');
    const dispatch = useDispatch();
    const classes = useStyles();

    const userPref = getUserPreference();
    const openModal = useSelector(openPodQualityManagement);

    let alertWait;

    const [searchDriverList, setSearchDriverList] = useState('');
    const [count, setCount] = useState(10);
    const [scopeType, setScopeType] = useState('0');
    const [dateFrom, setDateFrom] = useState(moment().format('YYYY-MM-DD'));
    const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
    const [isSub, setIsSub] = useState(true);
    const [batchNo, setBatchNo] = useState('');
    const [loading, setLoading] = useState(false);
    const [tnos, setTnos] = useState('');
    const [allDriver, setAllDriver] = useState(false);
    const [isQualified, setIsQualified] = useState('0');

    function handleClose() {
        dispatch(handlePodQualityManagement(false))
    }
    function initParams() {
        setSearchDriverList('');
        setCount(10);
        setScopeType('0');
        setDateFrom(moment().format('YYYY-MM-DD'));
        setDateTo(moment().format('YYYY-MM-DD'));
        setIsSub(true);
        setBatchNo('');
        setIsQualified('0');
    }
    function modifyValidTime(dateType) {
        const startTime = moment(dateFrom).startOf('day').unix();
        const endTime = moment(dateTo).endOf('day').unix();
        if (startTime >= endTime) {
            dispatch(showAlertSnackbar({ message: t('no_later'), type: 'warning' }))
            if (dateType === 'dateTo') {
                setDateTo(dateFrom);
            } else {
                setDateFrom(dateTo);
            }
        }
    }

    const handleSubmit = () => {
        let isResReturn = false;
        if (!searchDriverList && scopeType !== '2' && !allDriver) {
            setLoading(false);
            dispatch(showAlertSnackbar({ message: t('no_driver'), type: 'error' }));
            return;
        }
        let params = {}
        if (scopeType === '0') {
            params['report_type'] = searchType.DATE;
            params['start_time'] = moment(dateFrom).startOf('day').unix();
            params['end_time'] = moment(dateTo).endOf('day').unix();
            params['nums_of_report'] = count;
            params['driver_id'] = searchDriverList.trim().split(',').map(Number);
        } else if (scopeType === '1') {
            if (!batchNo) {
                dispatch(showAlertSnackbar({ message: t('fill_batch_no'), type: 'error' }))
                setLoading(false);
                return;
            }
            params['report_type'] = searchType.BATCH;
            params['nums_of_report'] = count;
            if (allDriver) {
                params['driver_id'] = [-1];
            } else {
                params['driver_id'] = searchDriverList.trim().split(',').map(Number);
            }
            params['batch_number'] = batchNo;
            if (isSub) {
                params['reference'] = searchType.SUB_REFERENCE
            } else {
                params['reference'] = searchType.REFERENCE
            }
        } else {
            params['report_type'] = searchType.MULTI_SEARCH;
            params['tnos'] = tnos.split(/\r?\n/);
        }
        params['is_qualified'] = Number(isQualified);
        setLoading(true);
        let occured = false;
        setTimeout(() => {
            if (!isResReturn) {
                dispatch(showAlertSnackbar({ message: t('please_wait'), type: 'info' }));
                occured = true;
            }
        }, 7000);
        alertWait = setInterval(() => {
            if (occured) {
                dispatch(showAlertSnackbar({ message: t('take_longer'), type: 'info' }));
            }
        }, 3000);
        downloadPodQualityExcelBlob(params)
        .catch((error) => {
            if (error?.status === 200) {
                dispatch(showAlertSnackbar({ message: t('no_data'), type: 'warning' }))
            } else {
                dispatch(showAlertSnackbar({ message: t('fetch_error'), type: 'error' }))
            }
        })
        .finally(() => {
            isResReturn = true;
            clearInterval(alertWait);
            setLoading(false);
        })
    }

    useEffect(() => {
        if(openModal) {
            initParams();
        }
        clearInterval(alertWait);
    }, [openModal])
    useEffect(() => {
        modifyValidTime('dateTo');
    }, [dateTo])
    useEffect(() => {
        modifyValidTime('dateFrom');
    }, [dateFrom])
    useEffect(() => {
        clearInterval(alertWait);
        return () => {
            clearInterval(alertWait);
        };
    }, [])

    return (
        <UniDialog
            title={t('title_pod_quality_management')}
            maxWidth='sm'
            open={openModal}
            onClose={handleClose}
            fullWidth={true}
            buttons={[
                {
                    color: 'primary',
                    text: t('common:reset'),
                    action: initParams
                },
                {
                    color: 'primary',
                    text: t('common:submit'),
                    action: handleSubmit
                }
            ]}
        >
            <Grid container space={3} alignItems="center" justify="center">
                <Grid xs={3}>{t("serch_scope")}</Grid>
                <Grid xs={9}>
                    <RadioGroup
                        row
                        value={scopeType}
                        onChange={(e) => { setScopeType(e.target.value) }}
                        style={{
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <FormControlLabel
                            id='pod_management_start_end_date_formcontrollabel'
                            value='0'
                            control={<Radio color='primary' />}
                            label={t('date')}
                        />
                        <FormControlLabel
                            id='pod_management_batch_subbatch_formcontrollabel'
                            value='1'
                            control={<Radio color='primary' />}
                            label={t('batch')}
                        />
                        <FormControlLabel
                            id='pod_management_multi_tno_formcontrollabel'
                            value='2'
                            control={<Radio color='primary' />}
                            label={t('multi')}
                        />
                    </RadioGroup>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={3}>
                    {t('quality_type')}
                </Grid>
                <Grid item xs={9}>
                    <RadioGroup
                        row
                        value={isQualified}
                        onChange={(e) => { setIsQualified(e.target.value) }}
                        style={{
                            display: 'flex'
                        }}
                    >
                        <FormControlLabel
                            id='pod_management_all_radio'
                            value='0'
                            control={<Radio color='secondary' />}
                            label={t('common:all')}
                        />
                        <FormControlLabel
                            id='pod_management_unqualified_radio'
                            value='1'
                            control={<Radio color='secondary' />}
                            label={t('qualified')}
                        />
                        <FormControlLabel
                            id='pod_management_qualified_radio'
                            value='2'
                            control={<Radio color='secondary' />}
                            label={t('unqualified')}
                        />
                    </RadioGroup>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                {
                    scopeType === '0' &&
                    <Grid container xs={12} className={classes.scopeStyle} alignItems="center" justify="center" style={{ padding: '20px 20px 20px 0px' }}>
                        <Grid xs={3}>{t('start_date')}</Grid>
                        <Grid xs={9}>
                            <TextField
                                id="pod_management_startdate_textfield"
                                type="date"
                                variant="outlined"
                                value={dateFrom}
                                onChange={(e)=>setDateFrom(e.target.value)}
                            />
                        </Grid>
                            <Grid xs={3} style={{ paddingTop: 20 }}>{t('end_date')}</Grid>
                            <Grid xs={9} style={{ paddingTop: 20 }}>
                            <TextField
                                id="pod_management_enddate_textfield"
                                type="date"
                                variant="outlined"
                                value={dateTo}
                                onChange={(e)=>setDateTo(e.target.value)}
                            />
                        </Grid>
                            <Grid item xs={12} style={{ marginTop: 20 }}>
                                <Divider />
                            </Grid>
                    </Grid>
                }
                {
                    scopeType === '1' &&
                    <>
                        <Grid xs={3}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        id='pod_management_select_subbatch_checkbox'
                                        color='secondary'
                                        checked={isSub}
                                        onChange={(e) => {
                                            setIsSub(e.target.checked)
                                        }}
                                    />
                                }
                                label={t('is_sub')}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        id='pod_management_select_batch_checkbox'
                                        color='secondary'
                                        checked={!isSub}
                                        onChange={(e) => {
                                            setIsSub(!e.target.checked)
                                            setAllDriver(false)
                                        }}
                                    />
                                }
                                label={t('is_ref')}
                            />
                            {
                                scopeType === '1' &&
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                id='pod_management_select_alldriver_checkbox'
                                                color='secondary'
                                                checked={allDriver}
                                                onChange={(e) => {
                                                    setAllDriver(!allDriver)
                                                    setIsSub(true)
                                                }}
                                            />
                                        }
                                        label={t('all_driver')}
                                    />
                            }
                        </Grid>
                        <Grid xs={9}>
                            <TextField
                                id="pod_management_input_batchnumber_textfield"
                                fullWidth
                                variant="outlined"
                                value={batchNo}
                                onChange={(e) => setBatchNo(e.target.value)}
                                placeholder={t('placeholder_batch')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                    </>
                }
                {
                    (scopeType === '0' || scopeType === '1' && allDriver === false) &&
                    <>
                        <Grid xs={3} className={classes.margin}>
                            <span>{t('driver_id')}</span>
                        </Grid>
                        <Grid xs={9} className={classes.margin}>
                            <TextField
                                id="pod_management_select_drivers_textfield"
                                rowsMax={10}
                                multiline
                                variant="outlined"
                                fullWidth
                                placeholder={t('select_drivers')}
                                value={searchDriverList}
                                onChange={(e) => setSearchDriverList(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                    </>
                }
                {
                    scopeType !== '2' &&
                    <>
                        <Grid xs={3} className={classes.margin}>
                            <span>{t('count')}</span>
                        </Grid>
                        <Grid xs={2} className={classes.margin}>
                            <TextField
                                id="pod_management_count_numbers_textfield"
                                number
                                variant="outlined"
                                type="number"
                                value={count}
                                onChange={(e) => {
                                    var value = parseInt(e.target.value, 10);
                                    if (value > COUNT_MAX) value = COUNT_MAX;
                                    if (value <= COUNT_MIN) value = COUNT_MIN;
                                    setCount(value);
                                }}
                                InputProps={{
                                    inputProps: {
                                        max: COUNT_MAX, min: COUNT_MIN
                                    }
                                }}
                            />
                        </Grid>
                        <Grid xs={7} className={classes.margin}>
                            <div>{t('placeholder_count', { maxNum: COUNT_MAX })}</div>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                    </>
                }   
                {
                    scopeType === '2' &&
                    <TextField
                        multiline
                        id="pod_management_multiple_tno_textfield"
                        rows={10}
                        label={t('multi_tips')}
                        placeholder={t('multi_tips')}
                        fullWidth={true}
                        autoFocus={true}
                        variant="outlined"
                        value={tnos}
                        onChange={(e) => setTnos(e.target.value)}
                        style={{ marginTop: 20 }}
                    />
                }
            </Grid>
            <FullscreenLoading open={loading} />
      </UniDialog>
    )
}

export default PodQualityManagement;
